import { useQuery } from '@apollo/client';
import { useAccount } from '@bnnvara/accounts';
import { useBrand } from '@bnnvara/brand';
import React from 'react';
import { withTheme } from 'styled-components';

import { FetchTeaser } from '../../api/queries/teaser.gql';
import BaseTeaser from '../BaseTeaser';
import Link from '../Link';
import MediaPlayerEmbed from '../MediaPlayerEmbed';

const TeaserContent = () => {
  const brand = useBrand();
  const {
    profile: { UID },
  } = useAccount();

  const { loading, error, data } = useQuery(FetchTeaser, {
    skip: brand.isCached,
    variables: {
      brandSlug: brand.slug,
      label: 'teasers',
      brandId: brand.id,
    },
  });

  if (brand.isCached) {
    return null;
  }

  if (loading || error || data.brand === null) return null;

  const { brandTeaserCollection: teaser } = data;

  const allTeaserItems = teaser ? teaser.items : [];

  if (teaser && allTeaserItems.length) {
    const items = allTeaserItems.slice(0, 3);

    const video = items[0].title && items[0].video && (
      <MediaPlayerEmbed
        type="video"
        title={items[0].title}
        id={items[0].video.id}
        siteName={brand.name}
        userId={UID}
      />
    );

    return <BaseTeaser items={items} video={video} LinkComponent={Link} />;
  }

  return null;
};

export default withTheme(TeaserContent);
